import {
  processVideoSizeLimitError,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export const getAddVideoError = ({
  error,
  i18n,
  aid,
  logger,
}) => {
  const { limit } = processVideoSizeLimitError({
    errorList: [error],
    aid,
    logger,
  }) || {};

  if (limit) {
    return i18n.getString(
      _TL_('We couldn\'t add your video because your account has exceeded the {{value}}-video asset limit. Please remove videos and try again.'),
      { value: limit }
    );
  }

  return i18n.getString(_TL_('We couldn\'t add your video. Please confirm that your video\'s URL is supported or refresh the page and try again.'));
};
